import moment from 'moment'
import { config } from '../utils/uploadImage'
import S3 from 'react-aws-s3'
import { CircularProgress, Typography } from '@material-ui/core'
import axios from 'axios'
import { itemsPerPage } from './data'
import { useContext, useRef } from 'react'
import Geocode from 'react-geocode'
import { toastMessage } from './AlertPopup'
import { UserContext } from '../context api/UserContext'
import { formTokenHeader } from '../lib/HeaderHelper'
import { getRoutes, returnObject } from '../utils/otherHelper'
import urlSearchParams from '../components/urlSearchParams'
import { API } from './API'

const otherRoutes = getRoutes()
export const mod_permission = [ 'CREATE','READ','UPDATE','DELETE','UPLOAD','FLAG'];
export const tempMappedModules = {
  EMPLOYEE: mod_permission,
  LEAD: mod_permission,
  AUDIT: mod_permission,
  SALES: mod_permission,
  PRODUCT: mod_permission,
  LEARNING: mod_permission,
  ORDER: mod_permission, 
  TRAVEL_ALLOWANCE: mod_permission,
  BEAT: mod_permission,
  DEALER_ONBOARDING: mod_permission,
  ATTENDANCE: mod_permission,
  TARGETS_INCENTIVES:mod_permission,
  MARKETING: mod_permission,
  CHECKIN_CHECKOUT:mod_permission,
  REWARDS:mod_permission,
  INVENTORY:mod_permission,
  MULTI_COUNTRY_CURRENCY:mod_permission
}
export const ROUTES = {
  ...otherRoutes.overviewRoute,
  ...otherRoutes.detailRoute,
  HOME: '/',
  SIGNUP: '/signup',
  CREATE_NEW_PASSWORD: '/create-new-password',
  ATTENDANCE: '/attendance',
  LEADS: '/leads',
  LEAVE_REQUESTS: '/leave-requests',
  EDIT_LEAVE_REQUEST: '/edit-leaveRequest/:leaveId',
  ALL_ATTENDANCE: '/all-attendance',
  ALL_EMPLOYEES: '/all-employees',
  DASHBOARD: '/dashboard',
  PRODUCTS: '/products',
  FORGOT_PASSWORD: '/forgot-password',
  CATEGORIES: '/all-categories',
  SUBCATEGORIES: '/all-subcategories',
  SETTING: '/setting',
  // LEADS: '/leads',
  PRODUCT_CATALOGUE: '/product-catalogue',
  BUSINESS: '/business_configuration',
  HOLIDAY_SETUP: '/holiday-setup',
  ADD_HOLIDAY: '/add-holiday',
  VIEW_HOLIDAY: '/add-holiday/:id',
  BUSINESS_ZONES: '/business_zones',
  BUSINESS_STORES: '/business_stores',
  SALES: '/sales',
  EDIT_EMPLOYEE: '/edit-employee/:employeeId',
  EMPLOYEE: '/employee',
  ADDPRODUCTS: '/add_products',
  TARGET: '/addTarget',
  ALL_TARGETS: '/all-targets',
  EDIT_ATTENDANCE: '/edit-attendance/:attendanceId',
  EDIT_TARGET: '/edit-target/:targetId',
  VIEW_EMPLOYEE: '/view-employee/:employeeId',
  VIEW_PRODUCTS: '/view-products/:productId',
  VIEW_TARGET: '/view-target/:targetId',
  MASTERS: '/masters',
  POSITION: '/position',
  LEAD_TYPE: '/lead-type',
  LEAVE_TYPE: '/leave-type',
  REGION: '/region',
  ZONE: '/zone',
  STATE: '/state',
  DISTRICT: '/district',
  AREA: '/area',
  STORE: '/store',
  TEMPLATE_CATEGORY: '/template-category',
  CHANNEL_TYPE: '/channel-type',
  POSITION_FORM: '/add-position',
  LEADTYPE_FORM: '/add-leadtype',
  LEAVETYPE_FORM: '/add-leavetype',
  REGION_FORM: '/add-region',
  ZONE_FORM: '/add-zone',
  STATE_FORM: '/add-state',
  DISTRICT_FORM: '/add-district',
  AREA_FORM: '/add-area',
  STORE_FORM: '/add-store',
  TEMPLATE_FORM: '/add-template',
  CHANNEL_FORM: '/add-channel',
  ADD_CATEGORY: '/add-category',
  EDIT_CATEGORY: '/edit-category/:categoryId',
  ADD_SUBCATEGORY: '/add-subcategory',
  EDIT_SUBCATEGORY: '/edit-subcategory/:subcategoryId',
  EDIT_PRODUCT: '/edit-product/:productId',
  VIEW_SUBCATEGORY: '/view-subcategory/:subcategoryId',
  VIEW_CATEGORY: '/view-category/:categoryId',
  VIEW_PRODUCT: '/view-product',
  VIEW_AREA: '/view-area/:areaId',
  VIEW_STORE: '/view-store/:storeId',
  VIEW_REGION: '/view-region/:regionId',
  VIEW_DISTRICT: '/view-district/:districtId',
  VIEW_ZONE: '/view-zone/:zoneId',
  VIEW_STATE: '/view-state/:stateId',
  VIEW_CITY: '/view-city/:cityId',
  CITY: '/city',
  CITY_FORM: '/add-city',
  VIEW_LEAD: '/view-lead/:leadId',
  VIEW_BUSINESS: '/view-business',
  EDIT_ZONE: '/edit-zone/:zoneId',
  EDIT_POSITION: '/edit-position/:positionId',
  EDIT_LEADTYPE: '/edit-leadtype/:leadTypeId',
  EDIT_LEAVETYPE: '/edit-leavetype/:leaveTypeId',
  EDIT_TOTALLEAVE: '/edit-totalLeave/:totalLeaveId',
  EDIT_REGION: '/edit-region/:regionId',
  ADD_LEAD: '/add-lead',
  EDIT_LEAD: '/edit-lead/:leadId',
  EDIT_STATE: '/edit-state/:stateId',
  EDIT_DISTRICT: '/edit-district/:districtId',
  EDIT_CITY: '/edit-city/:cityId',
  EDIT_AREA: '/edit-area/:areaId',
  EDIT_STORE: '/edit-store/:storeId',
  SINGLE_ATTENDANCE: '/single-employee/:employeeId',
  EDIT_CATALOG: '/edit-product-catalog/:productCatalougeId',
  ADD_PRODUCT_CATALOUGE: '/add-productcatalouge',
  VIEW_PRODUCT_CATALOUGE: '/view-productcatalouge/:productCatalougeId',
  EDIT_PRODUCT_CATALOUGE: '/edit-productcatalouge/:productCatalougeId',
  REPORTS: '/reports',

  // ATTENDANCE REPORTS
  ATTENDANCE_SUMMARY_REPORT: '/attendnace-summary-reports',
  CHECKIN_CHECKOUT_REPORT: '/checkin-checkout-report',
  IN_TIME_SUMMARY_REPORT: '/in-time-summary-report',
  MONTHLY_LATE_REPORT: '/monthly-late-report',
  LEAVE_REPORT: '/leave-report',
  PRODUCTIVE_TIME_REPORT: '/productive-time-report',
  TEAM_LEASE_DUMP_REPORT: '/team-lease-dump-report',

  // LEAD REPORTS
  LEAD_GENERATION_SUMMARY_REPORT: '/lead-generation-summary-report',
  LEAD_STATUS_REPORT: '/lead-status-report',
  LEAD_LIKELY_CLOSURE_REPORT: '/lead-likely-closure-report',
  PRODUCT_CATEGORY_LEAD_REPORT: '/product-category-lead-report',
  PRODUCT_CATEGORY_DETAILED_REPORT_MTD: '/product-category-detailed-report-mtd',
  PROMOTER_WISE_REPORT: '/promoter-wise-report',
  TSM_REPORT: '/tsm-report',
  TSM_DETAILED_REPORT_MTD: '/tsm-detailed-report-mtd',
  OUTLET_WISE_REPORT: '/outlet-wise-report',
  LEAD_AGING_REPORT: '/lead-aging-report',
  LEAD_DUMP_REPORT_FOR_PIVOT: '/lead-dump-report-for-pivot',

  TRAINING_REPORT: '/training-report',
  R_R_REPORT: '/r-r-report',
  MERCHANDISE_REPORT: '/merchandise-report',
  CUSTOMER_REPORT: '/customer-report',
  HYGIENE_IMPROVEMENT_REPORT: '/hygiene-improvement-report',
  TOTAL_LEAVE: '/total-leaves',
  ADD_TOTAL_LEAVE: '/add-total-leave',
  CUSTOMERS: '/customers',
  ADD_CUSTOMER: '/add-customer',
  EDIT_CUSTOMER: '/edit-customer/:customerId',
  VIEW_CUSTOMER: '/view-customer/:customerId',
  VIEW_POSITION: '/view-position/:positionId',
  VIEW_LEADTYPE: '/view-leadType/:leadTypeId',
  VIEW_LEAVETYPE: '/view-leaveType/:leaveTypeId',
  VIEW_TOTALLEAVE: '/view-totalLeave/:totalLeaveId',
  TAX: '/taxes',
  ADD_TAX: '/add-tax',
  EDIT_TAX: '/edit-tax/:taxId',
  VIEW_TAX: '/view-tax/:taxId',
  LEADSOURCE: '/lead-sources',
  ADD_LEADSOURCE: '/add-leadSource',
  EDIT_LEADSOURCE: '/edit-leadSource/:leadSourceId',
  VIEW_LEADSOURCE: '/view-leadSource/:leadSourceId',
  SCHEME: '/scheme',
  SALESDASHBOARD: '/sales-dashboard',
  ADD_SCHEME: '/add-scheme',
  EDIT_SCHEME: '/edit-scheme/:schemeId',
  VIEW_SCHEME: '/view-scheme/:schemeId',
  CUSTOMERTYPE: '/customer-types',
  ADD_CUSTOMERTYPE: '/add-customerType',
  EDIT_CUSTOMERTYPE: '/edit-customerType/:customerTypeId',
  VIEW_CUSTOMERTYPE: '/view-customerType/:customerTypeId',
  SALES_CHANNEL_TYPE: '/sales-channel-types',
  ADD_SALES_CHANNEL_TYPE: '/add-salesChannelType',
  EDIT_SALES_CHANNEL_TYPE: '/edit-salesChannelType/:salesChannelTypeId',
  VIEW_SALES_CHANNEL_TYPE: '/view-salesChannelType/:salesChannelTypeId',
  LEADTYPE_CONVERSION: '/leadtype-conversion',
  ADD_LEADTYPE_CONVERSION: '/add-leadtype-conversion',
  EDIT_LEADTYPE_CONVERSION: '/edit-leadtype-conversion/:convertLeadTypeId',
  VIEW_LEADTYPE_CONVERSION: '/view-leadtype-conversion/:convertLeadTypeId',
  PRIMARY_SALES: '/primary-sales',
  ADD_PRIMARY_SALES: '/add-primary-sales',
  EDIT_PRIMARY_SALES: '/edit-primary-sales/:primarySalesId',
  VIEW_PRIMARY_SALES: '/view-primary-sales/:primarySalesId',
  SALES_RETURN: '/sales-return',
  ADD_SALES_RETURN: '/add-sales-return',
  EDIT_SALES_RETURN: '/edit-sales-return/:salesReturnId',
  VIEW_SALES_RETURN: '/view-sales-return/:salesReturnId',
  INCENTIVE: '/incentive',
  ADD_INCENTIVE: '/add-incentive',
  EDIT_INCENTIVE: '/edit-incentive/:incentiveId',
  VIEW_INCENTIVE: '/view-incentive/:incentiveId',
  ADD_LEAD_PRODUCTS: '/add-lead-products',
  SELECT_LEAD_PRODUCTS: '/select-lead-products',
  ADD_ORDER: '/add-order/:leadId',
  ACHIEVEMENT_REPORT: '/achievement-report',
  QUATERLY_EARNING_REPORT: '/quarterly-earning-report',
  INCENTIVE_REPORT: '/incentive-report',
  QUATERLY_VS_ACTUAL_ACHIEVEMENT_REPORT: '/quarterly-vs-actual-achievement-report',

  // PHASE 2
  ADD_PERMISSION: '/add-permission',
  ALL_PERMISSIONS: '/permissions',
  EDIT_PERMISSION: '/edit-permission/:permissionId',
  VIEW_PERMISSION: '/view-permission/:permissionId',
  ADD_MODULEADMIN: '/add-moduleAdmin',
  ALL_MODULEADMINS: '/moduleAdmins',
  EDIT_MODULEADMIN: '/edit-moduleAdmin/:moduleAdminId',
  VIEW_MODULEADMIN: '/view-moduleAdmin/:moduleAdminId',
  UPLOAD_STATUS: '/upload-status',
  // CATEGORY_STATUS: '/upload-status/category/:statusId',
  // OVERVIEW_CATEGORY_STATUS: '/upload-status/overview/category',
  // OVERVIEW_SUBCATEGORY_STATUS: '/upload-status/overview/subcategory',
  // SUBCATEGORY_STATUS: '/upload-status/subcategory/:statusId',
  // OVERVIEW_PRODUCT_STATUS: '/upload-status/overview/product',
  // PRODUCT_STATUS: '/upload-status/product/:statusId',

  // OVERVIEW_SALES_STATUS: '/upload-status/overview/sales',
  // SALES_STATUS: '/upload-status/sales/:statusId',

  ALL_COMPANIES: '/super-admin/companies',
  EDIT_COMPANY: '/edit-company/:companyId',
  VIEW_COMPANY: '/view-company/:companyId',
  ADD_COMPANY: '/super-admin/addCompany',
  EDIT_SUPERADMIN: '/edit-superAdmin/:superAdminId',
  VIEW_SUPERADMIN: '/view-superAdmin/:superAdminId',
  ADD_SUPERADMIN: '/super-admin/addSuperAdmin',
  ALL_SUPERADMINS: '/super-admin/superadmins',
  
  ALL_SUBSCRIPTION_PLANS: '/super-admin/subscription-plans',
  ACTIVE_SUBSCRIPTIONS: '/super-admin/active-subscription-plans',
  ADD_SUBSCRIPTION_PLAN: '/super-admin/subscription-plans/add',
  EDIT_SUBSCRIPTION_PLAN: '/super-admin/subscription-plans/edit/:id',
  COPMANY_SUBSCRIPTION: '/business_configuration/subscriptions',

  //? Permissions
  PERMISSIONS: '/super-admin/permissions',
  ADD_SUPER_ADMIN_PERMISSIONS: '/super-admin/permissions/add',
  EDIT_SUPER_ADMIN_PERMISSIONS: '/super-admin/permissions/edit/:id',
  // PERMISSIONS: '/super-admin/permissions',

  EDIT_TRAININGCATEGORY: '/edit-training-category/:trainingCategoryId',
  VIEW_TRAININGCATEGORY: '/view-training-category/:trainingCategoryId',
  ADD_TRAININGCATEGORY: '/addTrainingCategory',
  ALL_TRAININGCATEGORY: '/trainingCategories',
  EDIT_TRAININGCATEGORYCONTENT: '/edit-training-category-content/:trainingCategoryContentId',
  VIEW_TRAININGCATEGORYCONTENT: '/view-training-category-content/:trainingCategoryContentId',
  ADD_TRAININGCATEGORYCONTENT: '/addTrainingCategoryContent',
  ALL_TRAININGCATEGORYCONTENT: '/trainingcategoryContents',
  EDIT_CONTENTQUESTION: '/edit-content-question/:contentQuestionId',
  VIEW_CONTENTQUESTION: '/view-content-question/:contentQuestionId',
  ADD_CONTENTQUESTION: '/addQuiz',
  ALL_CONTENTQUESTION: '/quizes',
  EDIT_UPLOAD_HEADER: '/edit-upload-header/:uploadHeaderId',
  VIEW_UPLOAD_HEADER: '/view-upload-header/:uploadHeaderId',
  ADD_UPLOAD_HEADER: '/addUploadHeader',
  ALL_UPLOAD_HEADERS: '/uploadHeaders',
  ALL_AUDITQUESTION: '/audit-questions',
  VIEW_AUDITQUESTION: '/view-audit-question/:auditDate',
  ALL_TASK: '/tasks',
  ADD_TASK: '/add-task',
  EDIT_TASK: '/edit-task/:taskId',
  ALL_AUDITSCORE: '/auditscores',
  ALL_AUDIT_TASK: '/audit-tasks',
  ALL_POS_TASK: '/pos-tasks',
  ADD_POS_TASK: '/add-pos-tasks',
  EDIT_POS_TASK: '/edit-pos-tasks/:taskId',
  ALL_REWARD: '/ALL_REWARD',
  AUDIT_DASHBOARD: '/AUDIT_DASHBOARD',
  OpenAuditTaskReport: '/OpenAuditTaskReport',
  OpenPosTaskReport: '/OpenPosTaskReport',
  GET_AUDIT_REPORT: '/GET_AUDIT_REPORT',
  GET_ACTIVE_CONTENT_REPORT: '/active-content-report',
  GET_ARCHIEVED_REPORT: '/archieved-report', //? archieved-report
  GET_INDUCTION_REPORT: '/induction-report', //? conduction-report
  GET_CONTENT_REPORT: '/content-report', //? content-report
  GET_LEARNING_SCORE_CARD_REPORT: '/learning-score-report', //? /learning-score-report
  GET_QUIZ_REPORT: '/quiz-report', //? quiz-report
  GET_LEADER_BOARD_REPORT: '/leader-board-report',
  GET_TOP_KBC_REPORT: '/top-kbc-report',

  // PHASE 3
  // Dealer Onboarding Masters

  BUSINESS_CATEGORY: '/business-category',
  ADD_BUSINESS_CATEGORY: '/add-business-category',
  EDIT_BUSINESS_CATEGORY: '/edit-business-category/:businessCategoryId',

  BUSINESS_TYPE: '/business-type',
  ADD_BUSINESS_TYPE: '/add-business-type',
  EDIT_BUSINESS_TYPE: '/edit-business-type/:businessTypeId',

  ALLOWANCE_TYPE: '/allowance-type',
  ADD_ALLOWANCE_TYPE: '/add-allowance-type',
  EDIT_ALLOWANCE_TYPE: '/edit-allowance-type/:allowanceTypeId',

  TRAVEL_CATEGORY: '/travel-category',
  ADD_TRAVEL_CATEGORY: '/add-travel-category',
  EDIT_TRAVEL_CATEGORY: '/edit-travel-category/:travelCategoryId',


  CHANNEL_TYPE_MASTER: '/channel-type-master',
  ADD_CHANNEL_TYPE_MASTER: '/add-channel-type-master',
  EDIT_CHANNEL_TYPE_MASTER: '/edit-channel-type-master/:channelTypeMasterId',

   // temp orders
   ADD_TMPORDER: '/add-tmp-order',
   MY_TMPORDERS: '/my-tmp-orders',
   VIEW_TMPORDER: '/view-tmp-order/:id',

  //? Travel Requests
  TRAVEL_REQUESTS: '/travel-requests/',
  ADD_TRAVEL_REQUESTS: '/travel-requests/add',
  EDIT_TRAVEL_REQUESTS: '/travel-requests/edit/:allowanceRequest',

  //? Beat Plans
  BEAT_PLANS: '/beat-plans',
  ADD_BEAT_PLAN: '/add-beat-plan',
  EDIT_BEAT_PLAN: '/edit-beat-plan/:id',
  GEOLOCATION: '/geo-location',

  //? Dealer Onboarding
  DEALER_ONBOARDING: '/dealer-onboarding-requests',
  ADD_DEALER_ONBOARDING: '/dealer-onboarding-requests/add',
  EDIT_DEALER_ONBOARDING: '/dealer-onboarding-requests/edit/:id',
}

//console.log('ROUTES : ', ROUTES)

export const GOOGLE_API = 'AIzaSyApm82MFXMcROWrHaGTj-auUcyOYQwBwsE'
export const error = 'error'
export const success = 'success'

export const toTitleCase =(str)=> {
  return str.replace(
    /\w\S*/g,
    function(txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    }
  );
}
export const formatDate = (date) => {
  return moment(date).format('Do MMMM YYYY')
}

export const formatTime = (date) => {
  return moment(date).format('h:mm a')
}

export const increasedDay = 60 * 60 * 24 * 1000
export const slicedDate = (date) => {
  return new Date(date.getTime() + increasedDay).toISOString().slice(0, 10)
}

// export const refreshData = localStorage.getItem("refreshData")
export const refreshData = localStorage.refreshData

export const isSelected = (name, selected) => selected.indexOf(name) !== -1

export const handleSelectedItem = (item, selected, setSelected) => {
  const selectedIndex = selected.indexOf(item)
  let newSelected = []

  if (selectedIndex === -1) {
    newSelected = newSelected.concat(selected, item)
  } else if (selectedIndex === 0) {
    newSelected = newSelected.concat(selected.slice(1))
  } else if (selectedIndex === selected.length - 1) {
    newSelected = newSelected.concat(selected.slice(0, -1))
  } else if (selectedIndex > 0) {
    newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1))
  }

  setSelected(newSelected)
}

export const handleSelectAllClick = (event, array, setSelected) => {
  if (event.target.checked) {
    const newSelecteds = array.map((n) => n)
    setSelected(newSelecteds)
    return
  }
  setSelected([])
}

export const handleFile = (e, setProgress, handleChange, setFileName) => {
  if (setFileName) setFileName(e.target.files[0].name)
  setProgress(true)
  const ReactS3Client = new S3(config)
  ReactS3Client.uploadFile(e.target.files[0], `picture/${Math.random()}-${e.target.files[0].name}`)
    .then((data) => {
      handleChange(data.location)
      //console.log(data.location)
      setProgress(false)
    })
    .catch((err) => {
      //console.log(err)
      setProgress(false)
    })
}

export const uploadFileToAws = async (file, multiple) => {
  if (multiple) {
    let arrImages = []
    Promise.all(file).then((values) => {
      const ReactS3Client = new S3(config)
      //   ReactS3Client.uploadFile(img, `product-catalogue/${Math.random()}${img.name}`)
      //     .then((data) => {
      //       // setProgress(false)
      //       //console.log('DATA LOCATION : ', data.location)
      //       arrImages.push(data.location)
      //     })
      //     .catch((err) => {
      //       // setProgress(false)
      //     })
    })

    // Object.keys(file).forEach((key) => {
    //   let img = file[key]
    //   // setProgress(true)

    //   const ReactS3Client = new S3(config)
    //   ReactS3Client.uploadFile(img, `product-catalogue/${Math.random()}${img.name}`)
    //     .then((data) => {
    //       // setProgress(false)
    //       //console.log('DATA LOCATION : ', data.location)
    //       arrImages.push(data.location)
    //     })
    //     .catch((err) => {
    //       // setProgress(false)
    //     })
    // })
    //console.log('ArrImage : ', arrImages)
    return arrImages
  } else {
    // setProgress(true)
    let tempData = {}
    const ReactS3Client = new S3(config)
    tempData = ReactS3Client.uploadFile(file, `picture/${Math.random()}-${file.name}`)
    // setProgress(true)
    if (tempData) {
      // setProgress(false)
      return tempData
    } else {
      // setProgress(true)
    }
    // .then((data) => {
    //   //console.log(data.location)
    //   // setProgress(false)
    //   return data.location
    // })
    // .catch((err) => {
    //   //console.log(err)
    //   // setProgress(false)
    // })
  }
}

export const uploadFilesToAws = async (file, setLoading = () => {}) => {
  //console.log('FILE : ', file)
  try {
    if (file) {
      setLoading(true)
      delete file.length
      file = Object.values(file)
      const ReactS3Client = new S3(config)
      let uploadArray = file.map((fil) => ReactS3Client.uploadFile(fil, `picture/${Math.random()}-${fil.name}`))
      //console.log('uploadArray : ', uploadArray)
      return Promise.allSettled(uploadArray)
        .then((data) => {
          // assuming all are deployed
          // if any left then status='rejected' and reason="xyz.."
          // if success then status is fulfilled with value
          setLoading(false)
          return data.map((item) => item.value.location)
        })
        .catch((err) => {
          setLoading(false)
          return toastMessage('Failed To Upload File', error)
        })
    }
  } catch (error) {
    console.log(error)
    return toastMessage('Failed To Upload File', error)
  }
}

export const rankOptions = [
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
  { value: 5, label: '5' },
  { value: 6, label: '6' },
  { value: 7, label: '7' },
  { value: 8, label: '8' },
  { value: 9, label: '9' },
  { value: 10, label: '10' },

]

export const generateRandomColor = (array) => {
  return Array(array.length)
    .fill('')
    .map((item) => {
      const gradient1 = `rgba(${Math.floor(Math.random() * 255) + 1}, ${Math.floor(Math.random() * 255) + 1}, ${Math.floor(Math.random() * 255) + 1}, 0.5)`
      return gradient1
    })
}

export const sortByName = (array, value) => {
  if (array) {
    if (value) {
      return array.sort((a, b) => a[value] && a[value].localeCompare(b[value] && b[value]))
    } else {
      return array.sort((a, b) => a.name && a.name.localeCompare(b.name && b.name))
    }
  } else {
    return []
  }
}

export const formatNumber = (number) => {
  const amount =
    '₹ ' +
    new Intl.NumberFormat('en-IN', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(number && parseFloat(number).toFixed())
  return amount
}

export const formatPercentage = (number) => {
  return (number * 100).toFixed() + '%'
}

export const capitalizeText = (text) => {
  return <Typography style={{ textTransform: 'lowercase' }}> {text} </Typography>
}

export const diffDateInHrs = (d1, d2) => {
  const diffInSec = (new Date(d2) - new Date(d1)) / 1000
  let min = Math.ceil(diffInSec / 60)
  const hr = Math.floor(min / 60)
  min = Math.ceil(min % 60)
  let productive = ''
  if (hr) productive += hr + 'hr '
  productive += min + 'min'
  return productive
}

// export const handleSwitchChange = (update,item) => {
//  updateStore({ ...item, active: !item.active, storeId: item._id })
// }

export const modulePermission = (attendanceModule, tempArray, label) => {
  let tempObj = {}
  tempObj = { module: label, subModule: tempArray }
  if (attendanceModule['CREATE']) {
    tempArray.push('CREATE')
  }
  if (attendanceModule['READ']) {
    tempArray.push('READ')
  }
  if (attendanceModule['UPDATE']) {
    tempArray.push('UPDATE')
  }
  if (attendanceModule['DELETE']) {
    tempArray.push('DELETE')
  }
  //console.log('TEMP OBJ : ', tempObj)
  return tempObj
}

export const filterPermission = (modules) => {
  let tempArray = []
  const attendanceModule = modules['ATTENDANCE']
  const employeeModule = modules['EMPLOYEE']
  const leadModule = modules['LEAD']

  if (attendanceModule['FLAG']) {
    modulePermission(attendanceModule, tempArray, 'ATTENDANCE')
  }
  if (employeeModule['FLAG']) {
    modulePermission(employeeModule, tempArray, 'EMPLOYEE')
  }
  if (leadModule['FLAG']) {
    modulePermission(leadModule, tempArray, 'LEAD')
  } else {
    return []
  }

  //console.log('TEMP ARRAY : ', tempArray)
}

export const nameWithCode = (name, code) => {
  return `${name} / ${code}`
}

export const checkCancelToken = () => {
  let cancelToken
  if (typeof cancelToken != typeof undefined) {
    return cancelToken.cancel('Operation canceled due to new request.')
  }
  cancelToken = axios.CancelToken.source()
  return cancelToken
}

export const paginatedData = (array, page) => {
  return array ? array.slice((page - 1) * itemsPerPage, page * itemsPerPage) : []
}

export const paginatePages = (array) => {
  return Array.isArray(array) ? Math.ceil(array && array.length / itemsPerPage) : Math.ceil(array / itemsPerPage)
}

export const filterString = (string, query) => {
  return string && string.toLowerCase().includes(query && query.toLowerCase())
}

export const getFullAddress = (lat, long) => {
  //console.log('LAT : ', lat.toString())
  //console.log('LONG : ', long.toString())
  Geocode.setApiKey('AIzaSyC3aTi1WI1ARhDgJCbSaf1L_UaAdzqsUBo')
  Geocode.enableDebug()

  Geocode.fromLatLng(lat.toString(), long.toString()).then(
    (response) => {
      const address = response.results[0].formatted_address
      //console.log(address)
      return address
    },
    (error) => {
      console.error(error)
    }
  )
}

export const isValidUrl = (string) => {
  let url

  try {
    url = new URL(string)
  } catch (_) {
    return false
  }

  if (string.includes('undefined')) {
    return false
  }
  return url.protocol === 'http:' || url.protocol === 'https:'
}

export const validityOptions = [
  { label: 'Monthly', value: 'MONTHLY' },
  { label: 'Quarterly', value: 'QUARTERLY' },
  { label: 'Half Yearly', value: 'HALF YEARLY' },
  { label: 'Yearly', value: 'YEARLY' },
  { label: 'Custom', value: 'CUSTOM' },
]

export const getNumbersByValidity = (validity) => {
  let array = []
  switch (validity) {
    case 'QUARTERLY':
      array = [...Array(5).keys()]
      //console.log('ARRAY : ', array)
      return array.slice(1)
    case 'MONTHLY':
      array = [...Array(13).keys()]
      return array.slice(1)
    case 'HALF YEARLY':
      array = [...Array(3).keys()]
      return array.slice(1)
    case 'YEARLY':
      array = [...Array(2).keys()]
      return array.slice(1)

    default:
      break
  }
}

export const calculateMonthRange = (fromDate, noOfMonths, validity) => {
  switch (validity) {
    case 'QUARTERLY':
      return moment(fromDate)
        .add(noOfMonths * 3, 'month')
        .toISOString()
        .slice(0, 10)
    case 'MONTHLY':
      return moment(fromDate)
        .add(noOfMonths * 12, 'month')
        .toISOString()
        .slice(0, 10)

    case 'HALF YEARLY':
      return moment(fromDate)
        .add(noOfMonths * 6, 'month')
        .toISOString()
        .slice(0, 10)

    case 'YEARLY':
      return moment(fromDate)
        .add(noOfMonths * 12, 'month')
        .toISOString()
        .slice(0, 10)

    default:
      break
  }
}

// export const sumMonthToQuarter = (val, validity) => {
//   let tempArray = []

//   switch (validity) {
//     case 'MONTHLY':

//     default:
//       break
//   }
// }

export const getUniqueValues = (value, index, self) => {
  return self.indexOf(value) === index
}

export const getNewToken = (cancelToken, setCancelToken) => {
  if (cancelToken != undefined) {
    cancelToken.cancel()
  }
  let tempCancelToken = axios.CancelToken.source()
  setCancelToken(tempCancelToken)
  return tempCancelToken.token
}

export const isArray = (value) => {
  return typeof value === 'object' && Array.isArray(value)
}

export const getImagePreview = (file) => {
  console.log({ file })
  if (file && !isArray(file) &&  typeof (file) === 'object') {
    // means it is object but not array
    // if(file.length) delete file.length
    return Object.values(file).map((item) => {
      console.log(item) 
      return URL.createObjectURL(item)})
  }
  return file
}

export const URLtoFile = async (dataurl, fileName) => {
  // const fetchedData = await fetch(dataurl)
  // //console.log('fetchedData : ', fetchedData)
  // const contentType = fetchedData.headers.get('content-type')
  // const blob = fetchedData.blob()
  // const file = new File([blob], fileName, { contentType })
  // //console.log('file', file)
  // return file
  // .then(async (response) => {
  //   const contentType = response.headers.get('content-type')
  //   const blob = await response.blob()
  //   const file = new File([blob], fileName, { contentType })
  //   //console.log('FILE @578 : ', file)
  //   return file
  // })
  // .catch((err) => //console.log(err))

  const getUrlExtension = (url) => {
    return url.split(/[#?]/)[0].split('.').pop().trim()
  }
  var imgExt = getUrlExtension(dataurl)

  const response = await fetch(dataurl)
  const blob = await response.blob()
  const file = new File([blob], 'image.' + imgExt, {
    type: blob.type,
  })

  return file
}

export const startDate = (date) => {
  const startDate = moment(date).startOf('month').toDate().setHours(0, 0, 0)
  // return `${startDate}T00:00:00.000Z`
  //console.log('START OF MONTH : ', startDate)
  return `${startDate}`
}

export const loadingAndText = (loading, text) => {
  return loading ? <CircularProgress size="25px" color="inherit" /> : text
}

// export const HeaderUserToken = () => {

//   return { header, user, token }
// }

export const convertArrayToObject = (array = ['k', 'kka']) => {
  let obj = {}
  array.forEach((val) => {
    obj[val] = val
  })

  return obj
}

export const getSampleCsvHeadings = (array) => {
  return (
    array &&
    array.map((item) => {
      return { label: item }
    })
  )
}

export const verifyExtension = (link) => {
  const types = new Map([
    ['jpg', 'image'],
    ['jpeg', 'image'],
    ['png', 'image'],
    ['svg', 'image'],
    ['gif', 'image'],
    ['mp4', 'video'],
    ['3gp', 'video'],
    ['mkv', 'video'],
    ['webm', 'video'],
  ])
  const url = new URL(link)
  const extension = url.pathname.split(/[#?]/)[0].split('.').pop().trim()
  //console.log('extension : ', extension)
  return types.get(extension)
}

export const subtractDays = (from, to) => {
  return `${moment().diff(from, 'days')} Days`
}

export const getAllData = async (url, dto = {}, state, setState) => {
  try {
    setState({ ...state, loading: true })

    const token = JSON.parse(localStorage.getItem('token'))
    const header = formTokenHeader(token)
    console.log({ token, header })
    axios
      .get(API[url](urlSearchParams(dto)), header)
      .then((data) => {
        console.log({ data })
        setState({ ...state, data: data.data.data, loading: false, paginate: data.data.paginate ?? {}, downloadData: data.data.download ?? {} })
      })
      .catch((err) => {
        console.log({ err })
        setState({ ...state, loading: false })
      })
  } catch (error) {
    console.log({ error })
  }
}
export 
const countrycodes = [
    {
      "code": "+7 840",
      "name": "Abkhazia"
    },
    {
      "code": "+93",
      "name": "Afghanistan"
    },
    {
      "code": "+355",
      "name": "Albania"
    },
    {
      "code": "+213",
      "name": "Algeria"
    },
    {
      "code": "+1 684",
      "name": "American Samoa"
    },
    {
      "code": "+376",
      "name": "Andorra"
    },
    {
      "code": "+244",
      "name": "Angola"
    },
    {
      "code": "+1 264",
      "name": "Anguilla"
    },
    {
      "code": "+1 268",
      "name": "Antigua and Barbuda"
    },
    {
      "code": "+54",
      "name": "Argentina"
    },
    {
      "code": "+374",
      "name": "Armenia"
    },
    {
      "code": "+297",
      "name": "Aruba"
    },
    {
      "code": "+247",
      "name": "Ascension"
    },
    {
      "code": "+61",
      "name": "Australia"
    },
    {
      "code": "+672",
      "name": "Australian External Territories"
    },
    {
      "code": "+43",
      "name": "Austria"
    },
    {
      "code": "+994",
      "name": "Azerbaijan"
    },
    {
      "code": "+1 242",
      "name": "Bahamas"
    },
    {
      "code": "+973",
      "name": "Bahrain"
    },
    {
      "code": "+880",
      "name": "Bangladesh"
    },
    {
      "code": "+1 246",
      "name": "Barbados"
    },
    {
      "code": "+1 268",
      "name": "Barbuda"
    },
    {
      "code": "+375",
      "name": "Belarus"
    },
    {
      "code": "+32",
      "name": "Belgium"
    },
    {
      "code": "+501",
      "name": "Belize"
    },
    {
      "code": "+229",
      "name": "Benin"
    },
    {
      "code": "+1 441",
      "name": "Bermuda"
    },
    {
      "code": "+975",
      "name": "Bhutan"
    },
    {
      "code": "+591",
      "name": "Bolivia"
    },
    {
      "code": "+387",
      "name": "Bosnia and Herzegovina"
    },
    {
      "code": "+267",
      "name": "Botswana"
    },
    {
      "code": "+55",
      "name": "Brazil"
    },
    {
      "code": "+246",
      "name": "British Indian Ocean Territory"
    },
    {
      "code": "+1 284",
      "name": "British Virgin Islands"
    },
    {
      "code": "+673",
      "name": "Brunei"
    },
    {
      "code": "+359",
      "name": "Bulgaria"
    },
    {
      "code": "+226",
      "name": "Burkina Faso"
    },
    {
      "code": "+257",
      "name": "Burundi"
    },
    {
      "code": "+855",
      "name": "Cambodia"
    },
    {
      "code": "+237",
      "name": "Cameroon"
    },
    {
      "code": "+1",
      "name": "Canada"
    },
    {
      "code": "+238",
      "name": "Cape Verde"
    },
    {
      "code": "+ 345",
      "name": "Cayman Islands"
    },
    {
      "code": "+236",
      "name": "Central African Republic"
    },
    {
      "code": "+235",
      "name": "Chad"
    },
    {
      "code": "+56",
      "name": "Chile"
    },
    {
      "code": "+86",
      "name": "China"
    },
    {
      "code": "+61",
      "name": "Christmas Island"
    },
    {
      "code": "+61",
      "name": "Cocos-Keeling Islands"
    },
    {
      "code": "+57",
      "name": "Colombia"
    },
    {
      "code": "+269",
      "name": "Comoros"
    },
    {
      "code": "+242",
      "name": "Congo"
    },
    {
      "code": "+243",
      "name": "Congo, Dem. Rep. of (Zaire)"
    },
    {
      "code": "+682",
      "name": "Cook Islands"
    },
    {
      "code": "+506",
      "name": "Costa Rica"
    },
    {
      "code": "+385",
      "name": "Croatia"
    },
    {
      "code": "+53",
      "name": "Cuba"
    },
    {
      "code": "+599",
      "name": "Curacao"
    },
    {
      "code": "+537",
      "name": "Cyprus"
    },
    {
      "code": "+420",
      "name": "Czech Republic"
    },
    {
      "code": "+45",
      "name": "Denmark"
    },
    {
      "code": "+246",
      "name": "Diego Garcia"
    },
    {
      "code": "+253",
      "name": "Djibouti"
    },
    {
      "code": "+1 767",
      "name": "Dominica"
    },
    {
      "code": "+1 809",
      "name": "Dominican Republic"
    },
    {
      "code": "+670",
      "name": "East Timor"
    },
    {
      "code": "+56",
      "name": "Easter Island"
    },
    {
      "code": "+593",
      "name": "Ecuador"
    },
    {
      "code": "+20",
      "name": "Egypt"
    },
    {
      "code": "+503",
      "name": "El Salvador"
    },
    {
      "code": "+240",
      "name": "Equatorial Guinea"
    },
    {
      "code": "+291",
      "name": "Eritrea"
    },
    {
      "code": "+372",
      "name": "Estonia"
    },
    {
      "code": "+251",
      "name": "Ethiopia"
    },
    {
      "code": "+500",
      "name": "Falkland Islands"
    },
    {
      "code": "+298",
      "name": "Faroe Islands"
    },
    {
      "code": "+679",
      "name": "Fiji"
    },
    {
      "code": "+358",
      "name": "Finland"
    },
    {
      "code": "+33",
      "name": "France"
    },
    {
      "code": "+596",
      "name": "French Antilles"
    },
    {
      "code": "+594",
      "name": "French Guiana"
    },
    {
      "code": "+689",
      "name": "French Polynesia"
    },
    {
      "code": "+241",
      "name": "Gabon"
    },
    {
      "code": "+220",
      "name": "Gambia"
    },
    {
      "code": "+995",
      "name": "Georgia"
    },
    {
      "code": "+49",
      "name": "Germany"
    },
    {
      "code": "+233",
      "name": "Ghana"
    },
    {
      "code": "+350",
      "name": "Gibraltar"
    },
    {
      "code": "+30",
      "name": "Greece"
    },
    {
      "code": "+299",
      "name": "Greenland"
    },
    {
      "code": "+1 473",
      "name": "Grenada"
    },
    {
      "code": "+590",
      "name": "Guadeloupe"
    },
    {
      "code": "+1 671",
      "name": "Guam"
    },
    {
      "code": "+502",
      "name": "Guatemala"
    },
    {
      "code": "+224",
      "name": "Guinea"
    },
    {
      "code": "+245",
      "name": "Guinea-Bissau"
    },
    {
      "code": "+595",
      "name": "Guyana"
    },
    {
      "code": "+509",
      "name": "Haiti"
    },
    {
      "code": "+504",
      "name": "Honduras"
    },
    {
      "code": "+852",
      "name": "Hong Kong SAR China"
    },
    {
      "code": "+36",
      "name": "Hungary"
    },
    {
      "code": "+354",
      "name": "Iceland"
    },
    {
      "code": "+91",
      "name": "India"
    },
    {
      "code": "+62",
      "name": "Indonesia"
    },
    {
      "code": "+98",
      "name": "Iran"
    },
    {
      "code": "+964",
      "name": "Iraq"
    },
    {
      "code": "+353",
      "name": "Ireland"
    },
    {
      "code": "+972",
      "name": "Israel"
    },
    {
      "code": "+39",
      "name": "Italy"
    },
    {
      "code": "+225",
      "name": "Ivory Coast"
    },
    {
      "code": "+1 876",
      "name": "Jamaica"
    },
    {
      "code": "+81",
      "name": "Japan"
    },
    {
      "code": "+962",
      "name": "Jordan"
    },
    {
      "code": "+7 7",
      "name": "Kazakhstan"
    },
    {
      "code": "+254",
      "name": "Kenya"
    },
    {
      "code": "+686",
      "name": "Kiribati"
    },
    {
      "code": "+965",
      "name": "Kuwait"
    },
    {
      "code": "+996",
      "name": "Kyrgyzstan"
    },
    {
      "code": "+856",
      "name": "Laos"
    },
    {
      "code": "+371",
      "name": "Latvia"
    },
    {
      "code": "+961",
      "name": "Lebanon"
    },
    {
      "code": "+266",
      "name": "Lesotho"
    },
    {
      "code": "+231",
      "name": "Liberia"
    },
    {
      "code": "+218",
      "name": "Libya"
    },
    {
      "code": "+423",
      "name": "Liechtenstein"
    },
    {
      "code": "+370",
      "name": "Lithuania"
    },
    {
      "code": "+352",
      "name": "Luxembourg"
    },
    {
      "code": "+853",
      "name": "Macau SAR China"
    },
    {
      "code": "+389",
      "name": "Macedonia"
    },
    {
      "code": "+261",
      "name": "Madagascar"
    },
    {
      "code": "+265",
      "name": "Malawi"
    },
    {
      "code": "+60",
      "name": "Malaysia"
    },
    {
      "code": "+960",
      "name": "Maldives"
    },
    {
      "code": "+223",
      "name": "Mali"
    },
    {
      "code": "+356",
      "name": "Malta"
    },
    {
      "code": "+692",
      "name": "Marshall Islands"
    },
    {
      "code": "+596",
      "name": "Martinique"
    },
    {
      "code": "+222",
      "name": "Mauritania"
    },
    {
      "code": "+230",
      "name": "Mauritius"
    },
    {
      "code": "+262",
      "name": "Mayotte"
    },
    {
      "code": "+52",
      "name": "Mexico"
    },
    {
      "code": "+691",
      "name": "Micronesia"
    },
    {
      "code": "+1 808",
      "name": "Midway Island"
    },
    {
      "code": "+373",
      "name": "Moldova"
    },
    {
      "code": "+377",
      "name": "Monaco"
    },
    {
      "code": "+976",
      "name": "Mongolia"
    },
    {
      "code": "+382",
      "name": "Montenegro"
    },
    {
      "code": "+1664",
      "name": "Montserrat"
    },
    {
      "code": "+212",
      "name": "Morocco"
    },
    {
      "code": "+95",
      "name": "Myanmar"
    },
    {
      "code": "+264",
      "name": "Namibia"
    },
    {
      "code": "+674",
      "name": "Nauru"
    },
    {
      "code": "+977",
      "name": "Nepal"
    },
    {
      "code": "+31",
      "name": "Netherlands"
    },
    {
      "code": "+599",
      "name": "Netherlands Antilles"
    },
    {
      "code": "+1 869",
      "name": "Nevis"
    },
    {
      "code": "+687",
      "name": "New Caledonia"
    },
    {
      "code": "+64",
      "name": "New Zealand"
    },
    {
      "code": "+505",
      "name": "Nicaragua"
    },
    {
      "code": "+227",
      "name": "Niger"
    },
    {
      "code": "+234",
      "name": "Nigeria"
    },
    {
      "code": "+683",
      "name": "Niue"
    },
    {
      "code": "+672",
      "name": "Norfolk Island"
    },
    {
      "code": "+850",
      "name": "North Korea"
    },
    {
      "code": "+1 670",
      "name": "Northern Mariana Islands"
    },
    {
      "code": "+47",
      "name": "Norway"
    },
    {
      "code": "+968",
      "name": "Oman"
    },
    {
      "code": "+92",
      "name": "Pakistan"
    },
    {
      "code": "+680",
      "name": "Palau"
    },
    {
      "code": "+970",
      "name": "Palestinian Territory"
    },
    {
      "code": "+507",
      "name": "Panama"
    },
    {
      "code": "+675",
      "name": "Papua New Guinea"
    },
    {
      "code": "+595",
      "name": "Paraguay"
    },
    {
      "code": "+51",
      "name": "Peru"
    },
    {
      "code": "+63",
      "name": "Philippines"
    },
    {
      "code": "+48",
      "name": "Poland"
    },
    {
      "code": "+351",
      "name": "Portugal"
    },
    {
      "code": "+1 787",
      "name": "Puerto Rico"
    },
    {
      "code": "+974",
      "name": "Qatar"
    },
    {
      "code": "+262",
      "name": "Reunion"
    },
    {
      "code": "+40",
      "name": "Romania"
    },
    {
      "code": "+7",
      "name": "Russia"
    },
    {
      "code": "+250",
      "name": "Rwanda"
    },
    {
      "code": "+685",
      "name": "Samoa"
    },
    {
      "code": "+378",
      "name": "San Marino"
    },
    {
      "code": "+966",
      "name": "Saudi Arabia"
    },
    {
      "code": "+221",
      "name": "Senegal"
    },
    {
      "code": "+381",
      "name": "Serbia"
    },
    {
      "code": "+248",
      "name": "Seychelles"
    },
    {
      "code": "+232",
      "name": "Sierra Leone"
    },
    {
      "code": "+65",
      "name": "Singapore"
    },
    {
      "code": "+421",
      "name": "Slovakia"
    },
    {
      "code": "+386",
      "name": "Slovenia"
    },
    {
      "code": "+677",
      "name": "Solomon Islands"
    },
    {
      "code": "+27",
      "name": "South Africa"
    },
    {
      "code": "+500",
      "name": "South Georgia and the South Sandwich Islands"
    },
    {
      "code": "+82",
      "name": "South Korea"
    },
    {
      "code": "+34",
      "name": "Spain"
    },
    {
      "code": "+94",
      "name": "Sri Lanka"
    },
    {
      "code": "+249",
      "name": "Sudan"
    },
    {
      "code": "+597",
      "name": "Suriname"
    },
    {
      "code": "+268",
      "name": "Swaziland"
    },
    {
      "code": "+46",
      "name": "Sweden"
    },
    {
      "code": "+41",
      "name": "Switzerland"
    },
    {
      "code": "+963",
      "name": "Syria"
    },
    {
      "code": "+886",
      "name": "Taiwan"
    },
    {
      "code": "+992",
      "name": "Tajikistan"
    },
    {
      "code": "+255",
      "name": "Tanzania"
    },
    {
      "code": "+66",
      "name": "Thailand"
    },
    {
      "code": "+670",
      "name": "Timor Leste"
    },
    {
      "code": "+228",
      "name": "Togo"
    },
    {
      "code": "+690",
      "name": "Tokelau"
    },
    {
      "code": "+676",
      "name": "Tonga"
    },
    {
      "code": "+1 868",
      "name": "Trinidad and Tobago"
    },
    {
      "code": "+216",
      "name": "Tunisia"
    },
    {
      "code": "+90",
      "name": "Turkey"
    },
    {
      "code": "+993",
      "name": "Turkmenistan"
    },
    {
      "code": "+1 649",
      "name": "Turks and Caicos Islands"
    },
    {
      "code": "+688",
      "name": "Tuvalu"
    },
    {
      "code": "+1 340",
      "name": "U.S. Virgin Islands"
    },
    {
      "code": "+256",
      "name": "Uganda"
    },
    {
      "code": "+380",
      "name": "Ukraine"
    },
    {
      "code": "+971",
      "name": "United Arab Emirates"
    },
    {
      "code": "+44",
      "name": "United Kingdom"
    },
    {
      "code": "+1",
      "name": "United States"
    },
    {
      "code": "+598",
      "name": "Uruguay"
    },
    {
      "code": "+998",
      "name": "Uzbekistan"
    },
    {
      "code": "+678",
      "name": "Vanuatu"
    },
    {
      "code": "+58",
      "name": "Venezuela"
    },
    {
      "code": "+84",
      "name": "Vietnam"
    },
    {
      "code": "+1 808",
      "name": "Wake Island"
    },
    {
      "code": "+681",
      "name": "Wallis and Futuna"
    },
    {
      "code": "+967",
      "name": "Yemen"
    },
    {
      "code": "+260",
      "name": "Zambia"
    },
    {
      "code": "+255",
      "name": "Zanzibar"
    },
    {
      "code": "+263",
      "name": "Zimbabwe"
    }
  ]